// src/constants/analysisModels.js
//
// Models a user can pick per checklist for the AI analysis. The `id` is the contract
// shared with the backend: functions/index.js → ANALYSIS_MODEL_CATALOG resolves each id
// to a provider + API model string + request params (thinking level / reasoning effort).
// Keep ids in sync between the two files.

export const ANALYSIS_MODELS = [
  { id: 'gemini-3.5-flash', label: 'Gemini 3.5 Flash (մտածող)', description: 'Արագ, խելացի, խորհուրդ տրվող կանխադրված տարբերակ' },
  { id: 'gemini-3.1-pro', label: 'Gemini 3.1 Pro (մտածող)', description: 'Ավելի բարձր որակ, բայց ավելի թանկ ու դանդաղ' },
  { id: 'gpt-5.5', label: 'GPT-5.5 (մտածող)', description: 'OpenAI-ի առաջատար մտածող մոդելը' },
  { id: 'gpt-4.1', label: 'GPT-4.1 (արագ)', description: 'Արագ աշխատող, բայց երկար չմտածող տարբերակ' },
];

export const DEFAULT_ANALYSIS_MODEL_ID = 'gemini-3.5-flash';

export const getAnalysisModelLabel = (id) =>
  (ANALYSIS_MODELS.find((m) => m.id === id) || {}).label || id || '';
